import { TutorialParent } from "../TutorialParent";
import { Translate } from "components/common/Translate/Translate";

export const ColorPickerTutorial = () => {
    return (
        <div className="py-20">
            <TutorialParent>
                <div className="flex flex-col items-center w-full gap-7">
                    {/* header */}
                    <h2 className="block font-semibold sub-heading mb-3 text-center w-full">
                        <Translate keyName="tutorial-title" />
                    </h2>
                    {/* tutorial points */}
                    <ul className="flex flex-col gap-2">
                        <li>
                            <Translate keyName="tutorial-1" />{" "}
                        </li>
                        <li>
                            <Translate keyName="tutorial-2" />
                        </li>
                        <li>
                            <Translate keyName="tutorial-3" />
                        </li>
                    </ul>
                </div>
            </TutorialParent>
        </div>
    );
};
